import React from "react";
import "../Account.css"
import { Link } from "react-router-dom";
import Logo from "../../image/Logo.png"

const SignupHeader = () => {
    return (
        <div className="account_header_image">
            <Link to="/"><img src={Logo} alt="logo" />
            <h2 className="company_name">GEOINFOTECH <br />
                <span>ACADEMY</span></h2></Link>
        </div>
    )
}
export default SignupHeader